import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../wizard/types";
import { ViewCourse } from "../components";

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const { values } = useFormState();

  return (
    <form noValidate onSubmit={handleSubmit}>
      <ViewCourse {...values.injectedData.data} />
    </form>
  );
};

export default Content;
